import { render, staticRenderFns } from "./CardMaisFiltros.vue?vue&type=template&id=2c38475c&scoped=true"
import script from "./CardMaisFiltros.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardMaisFiltros.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CardMaisFiltros.vue?vue&type=style&index=0&id=2c38475c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c38475c",
  null
  
)

export default component.exports